// extracted by mini-css-extract-plugin
export default {"coin":"CoinGif_coin__OxXIO"};